export enum OtherAssetType {
  Business,
  RealEstate,
  Pension,
  Miscellaneous,
  DeferredCompensation,
}

export const ASSET_NAME_MAP: Record<OtherAssetType, string> = {
  [OtherAssetType.Business]: 'Business Asset',
  [OtherAssetType.RealEstate]: 'Real Estate',
  [OtherAssetType.Pension]: 'Pension',
  [OtherAssetType.Miscellaneous]: 'Miscellaneous Asset',
  [OtherAssetType.DeferredCompensation]: 'Deferred Compensation',
};

export interface EarmarkDTO {
  Type: string;
  Tooltip: string;
}

export interface EarmarkOptionDTO {
  label: string;
  value: string;
}

export interface OwnerOptionsDTO {
  People: string[];
  Trusts: string[];
}

export interface ColumnHeader {
  text: string;
  align?: 'left' | 'center' | 'right';
}

export const ADD_ASSET_SUCCESS_MESSAGE = 'New asset added successfully.';
export const EDIT_ASSET_SUCCESS_MESSAGE = 'The asset saved successfully.';
